import React from 'react';
import { VerificationQuestionMessage } from 'types/chat.types';
import VerificationQuestion from 'components/molecules/chat/VerificationQuestion';
import Icon from 'components/atoms/Icon';

interface VerificationMessageProps {
  message: VerificationQuestionMessage;
}

const VerificationMessage: React.FC<VerificationMessageProps> = ({ message }) => {
  const { question, timestamp } = message;

  return (
    <div className="self-start w-full flex flex-col">
      <div className="bg-white border border-gray-200 px-4 py-4 rounded-2xl rounded-bl-md max-w-3xl">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
          <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
            <Icon name="help" className="w-5 h-5 text-gray-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Verification Required</h3>
            <p className="text-xs text-gray-500">Please provide the missing information</p>
          </div>
        </div>

        {/* Question content */}
        <VerificationQuestion question={question} />
      </div>

      <div className="text-xs text-gray-400 mt-1 ml-2">
        {timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>
    </div>
  );
};

export default VerificationMessage;
